<h1 class="table__title">Comments</h1>
<div class="table__control">
  <button *ngIf="addButton" mat-raised-button class="grey-btn" (click)="addComment($event)">
    <mat-icon><img src="assets/images/icon-add.svg" /></mat-icon>
    Comment
  </button>
</div>
<ng-template #noComments>
  <h2>No Comments</h2>
</ng-template>
<div class="table__container">
  <table *ngIf="comments?.length > 0;else noComments" class="table__inner" mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="Date">
      <th mat-header-cell *matHeaderCellDef>Date</th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.AnnotationDate | aspenDate }}</td>
    </ng-container>

    <ng-container matColumnDef="Username">
      <th mat-header-cell *matHeaderCellDef>Username</th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.AnnotationUser }}</td>
    </ng-container>

    <ng-container matColumnDef="AnnotationText">
      <th mat-header-cell *matHeaderCellDef>Comment</th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.AnnotationText }}</td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<div class="table__pagination">
  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>
